import React, { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase'; // your firebase config file
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext'; // Make sure this path is correct

function Login() {
  // 1. Get user and logout function from our AuthContext
  const { currentUser, logout } = useAuth();
  
  // State for the login form inputs
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/portal';
  // This function handles the form submission for logging in
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // On success, Firebase's onAuthStateChanged listener in your
      // AuthContext will automatically update the currentUser state.
      // You can navigate away or let the component re-render.
      navigate(from, { replace: true }); // Or wherever you want to go after login
    } catch (err) {
      navigate('/login', { state: { error: 'Failed to log in. Please check your email and password.' } });
      setError('Failed to log in. Please check your email and password.');
      console.error("Login Error:", err);
    }
  };

  // 2. This function handles logging out
  const handleLogout = async () => {
    setError('');
    // Defensive check: Ensure logout is a function before calling it.
    // This helps debug issues where the component might not be wrapped
    // in the AuthProvider correctly.
    if (typeof logout === 'function') {
      try {
        await logout();
        // You can navigate to the home page or show a message
        // Add a small delay to allow auth state to update
        setTimeout(() => {
          navigate('/', { replace: true }); 
        }, 100); // 100ms delay
      } catch (err) {
        setError('Failed to log out.');
        console.error("Logout Error:", err);
      }
    } else {
      const logoutError = 'Logout function is not available. Check AuthProvider context.';
      setError(logoutError);
      console.error(logoutError);
    }
  };

  // 3. Conditionally render content based on `currentUser`
  return (
    <div>
      {currentUser ? (
        // If a user is logged in, show this:
        <div>
          <p class="welcome-login">Welcome, {currentUser.email}
          <button className="login-btn" onClick={handleLogout}>Log Out</button>
          </p>
        </div>
      ) : (
        // If no user is logged in, show the login form:
        <div>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <form className="col-12 col-lg-auto mb-2 mb-lg-auto" onSubmit={handleLogin}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
              className="login-form fa-search"
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              className="login-form fa-search"
            />
            <button className="login-btn" type="submit">Log In</button>
          </form>
        </div>
      )}
    </div>
  );
}

export default Login;
